import i18n from '@/i18n/i18n';
import type { InvitationResponse } from 'we-tree-api-client/v2';

/** Label for an invitee in list UIs — never email (PII). */
export function getInvitationInviteeLabel(
  invitation: InvitationResponse,
  resolveMemberName: (familyMemberId: string) => string | null | undefined
): string {
  if (invitation.familyMemberId) {
    const name = resolveMemberName(invitation.familyMemberId);
    if (name?.trim()) return name.trim();
  }
  return i18n.t('forms:invitations.unlinkedInvite');
}
